$(function() {
    $('input.tagsinput').tagsinput('items');
});
